/* GW Collection Sort — <gw-collection-sort>
   The mobile sort pill for sections/gw-collection-grid.liquid.

   WHY THIS EXISTS AT ALL. The mobile frame (29:5475) draws Filters and Sort as
   a 2-up row. Below 1025 the theme's own `collection-filtering-form` is
   position:fixed — the form IS the off-canvas drawer, and both of its sort
   selects (#SortBydesktop and #SortBymobile) live inside it, so neither can be
   placed in that row by CSS alone.

   WHAT IT DOES NOT DO: sort. It renders the visible pill and then hands the
   chosen value to the theme's OWN #SortBydesktop, so component-filtering.js
   does the fetch, the history push and the grid swap exactly as it does on
   desktop. Their handleSortByChange() reads event.target.value, writes
   #sort_by_input and dispatches `input` on it, which bubbles to the form and
   hits their 800ms debounced submit — so a plain `change` is the whole
   contract. Their own `input` listener on the select is a
   stopPropagation guard, which is why this dispatches `change`, never `input`.

   Markup contract:
     <gw-collection-sort>
       <label for=...>            (optional)
       <select data-gw-sort>      (required)
       <span>chevron</span>       (optional)
     </gw-collection-sort> */

class GwCollectionSort extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;

    this.select = this.querySelector('[data-gw-sort]');
    if (!this.select) return;

    this.bound = true;
    this.select.addEventListener('change', () => {
      this.paint(this.select.value);
      this.apply(this.select.value);
    });
  }

  /* The select is transparent, so the visible value is ours to keep current.
     The pill sits OUTSIDE #CollectionProductGrid and so survives the engine's
     swap untouched — nothing else will repaint it. */
  paint(value) {
    const out = this.querySelector('[data-gw-sort-value]');
    const option = this.select.options[this.select.selectedIndex];
    if (out && option) out.textContent = option.text;
    void value;
  }

  apply(value) {
    const themeSelect = document.querySelector('#SortBydesktop');

    if (themeSelect && customElements.get('collection-filtering-form')) {
      themeSelect.value = value;
      themeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* No engine — the snippet was not rendered, or its script never ran. A
       plain navigation sorts just as well; drop `page` so the first page of
       the new order is served rather than a page that may not exist. */
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }
}

if (!customElements.get('gw-collection-sort')) {
  customElements.define('gw-collection-sort', GwCollectionSort);
}

if (window.wetheme && window.wetheme.webcomponentRegistry) {
  window.wetheme.webcomponentRegistry.register({
    key: 'gw-collection-sort',
    element: 'gw-collection-sort',
  });
}
